import * as React from 'react';
import { connect } from 'react-redux';
import { Grid, Dialog, DialogTitle, DialogContent, DialogActions, Checkbox, FormControlLabel } from '@material-ui/core';
import { StyledComponentProps } from '@material-ui/core/styles';
import { IMediaQueryProps, WithMediaQuery } from '../../../../layout/withMediaQuery';
import { IApplicationState } from '../../../../store/ApplicationState';
import { IState as IMedicalExaminationState } from '../../../../common/store/medicalExaminations/state';
import { IActions as IMedicalExaminationActions } from '../../../../common/store/medicalExaminations/actions/creators';
import { actionCreator as medicalExaminationsActions } from '../../../../common/store/medicalExaminations/actions/creators';
import SaveButton from '../../../../ui-components/Button/SaveButton';
import CancelButton from '../../../../ui-components/Button/CancelButton';
import DatePicker from '../../../../ui-components/DatePicker/DatePicker';
import { medicalExamination } from '../../../../model/medicalexamination';
import TextField from '../../../../ui-components/TextField/TextField';
import { DeleteX } from '../../../drafts/components/DeleteButton';
import { CheckBox } from '@material-ui/icons';

interface IProps extends IMediaQueryProps, IMedicalExaminationActions, IMedicalExaminationState, IInnerProps {
}

interface IInnerProps extends StyledComponentProps {
    onCancel: () => any;
    onSave: (item: medicalExamination) => any;
    onDelete: (item: medicalExamination) => any;
    medicalExaminationSelected: medicalExamination;
    open: boolean;
}

// interface IInnerState {
//     // reservationList: INormalizedObjects<reservation[]>;
// }

export const ValidateMedicalExaminationDialog = (props: IProps) => {
    // const [medicalExamination, setMedicalExamination] = React.useState<medicalExamination>(props.medicalExaminationSelected);
    const [notes, setNotes] = React.useState<string>();
    const [isCopiaConforme, setCopiaConforme] = React.useState<boolean>();
    // const [daysExtra, setDaysExtra] = React.useState<number>();
    const [validFrom, setValidFrom] = React.useState<Date>();
    const [expireTo, setExpireTo] = React.useState<Date>();
    // const [subscriptionType, setSubscriptionType] = React.useState<SelectItem>();
    // const ClearItemsRef = React.useRef(() => { });

    // React.useEffect(() => {
    //     changeSubscriptionValue(props.selectedSubscription)
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [props.selectedSubscription])

    // React.useEffect(() => {
    //     console.info("-------------------------------x-x-x-x-x-x-x-props.open--------------------3-", props.open);
    //     if (props.open === true) {
    //         // ClearItemsRef.current();
    //         // setNotes('');
    //         // // setAccessesExtra(0);
    //         // // setDaysExtra(0);
    //         // setValidFrom(new Date());
    //         // setExpireTo(moment(new Date()).add(12, 'M').toDate());
    //         // // setSubscriptionType({ name: 'Abbonamento', value: 'MENSILE' });
    //     }
    // }, [props.open])

    React.useEffect(() => {
        // console.info("-------------------------------x-x-x-x-x-x-x-selected--------------------1-", props.medicalExaminationSelected);
        if (props.open === true) {
            // ClearItemsRef.current();
            // setMedicalExamination(props.medicalExaminationSelected);
            setNotes(props.medicalExaminationSelected.notes);
            setValidFrom(new Date(props.medicalExaminationSelected.validFrom));
            setExpireTo(new Date(props.medicalExaminationSelected.expiresOn));
            setCopiaConforme(props.medicalExaminationSelected.isCopiaConforme)
        }
    }, [props.medicalExaminationSelected])

    // React.useEffect(() => {
    //     console.info("-------------------------------x-x-x-x-x-x-x-SAVE--------------------4-", medicalExamination);
    //     if (props.open === true) {
    //         console.log("on save:", medicalExamination);
    //         props.onSave(medicalExamination);
    //     }
    // }, [medicalExamination])

    const Save = () => {
        // console.info("-------------------------------x-x-x-x-x-x-x-save---------------------", medicalExamination);
        // console.info(validFrom);
        // console.info(expireTo);
        // console.info(notes);

        // VALIDATE DATE -> validFrom
        // if (Object.prototype.toString.call(validFrom) === "[object Date]") {
        //     // it is a date
        //     if (isNaN(validFrom.getTime())) {  // d.valueOf() could also work
        //         // date is not valid
        //         return;
        //     } else {
        //         // date is valid
        //     }
        // } else {
        //     // not a date
        //     return;
        // }

        const i = {
            ...props.medicalExaminationSelected,
            validFrom: validFrom,
            expiresOn: expireTo,
            notes: notes,
        }
        // console.log("on save x:", validFrom, expireTo, notes);
        // console.log("on save Y:", i);

        props.onSave(i);

        // console.log("-------------------------------x-x-x-x-x-x-x---------------------ok-");
    }

    const changeExpireDate = (date: Date) => {
        setExpireTo(date);
    }
    const changeValidFromDate = (date: Date) => {
        setValidFrom(date);
    }

    const deleteinfo = async () => {
        console.log("delete props.medicalExaminationSelected:", props.medicalExaminationSelected);

        const i = {
            ...props.medicalExaminationSelected,
            validFrom: validFrom,
            expiresOn: expireTo,
            notes: notes,
        }

        props.onDelete(i);
    }

    const doClose = () => {
        props.onCancel()
    }

    var title = "Validazione Visita Medica";

    return (
        <Dialog
            open={props.open}
            onClose={doClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            {<DialogTitle id="alert-dialog-title">{title}</DialogTitle>}
            <DialogContent>
                {/* className={this.props.classes.reservationSlotDetailDialogContent} */}
                <Grid container>
                    <Grid item sm={12}>
                        <DatePicker
                            key={`dataInizioValidita-from-date-picker`}
                            label="Data inizio validità"
                            fullWidth
                            value={validFrom}
                            onChange={(d) => { changeValidFromDate(d); }}
                        />
                    </Grid>
                    <Grid item sm={12}>
                        <DatePicker
                            key={`dataFineValidita-from-date-picker`}
                            label="Data fine validità"
                            fullWidth
                            disabled={false}
                            minDate={new Date()}
                            value={expireTo}
                            onChange={(d) => { changeExpireDate(d); }}
                        />
                    </Grid>
                    <Grid item sm={12}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isCopiaConforme}
                                    // onChange={(e) => this.handleIsActive(e.target.checked)}
                                    value="1"
                                    color="primary"
                                />

                            }
                            label={'Copia conforme originale'}
                        />
                    </Grid>
                    <Grid item sm={12}>
                        <TextField
                            label="Note"
                            onChange={(val) => setNotes(val)}
                            value={notes}
                        />
                    </Grid>
                </Grid>
            </DialogContent >
            <DialogActions>
                {/* className={this.props.classes.contactReservationDialogActions} */}
                {/* <DeleteIconButton onClick={deleteinfo} /> */}
                <DeleteX action={deleteinfo} text={'Eliminazione documento. Sei sicuro di voler proseguire?'} />
                <SaveButton onClick={Save} />
                <CancelButton onClick={doClose} />
            </DialogActions>
        </Dialog >
    );
}


const mapStateToProps = (state: IApplicationState, ownProps: any): any => {
    return {
        ...ownProps,
        ...state.medicalExaminations
    }
}

const mapDispatchToProps = (dispatch: any) => ({
    ...medicalExaminationsActions(dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)((WithMediaQuery(ValidateMedicalExaminationDialog))) as React.ComponentType<IInnerProps>;